import { LegrandGateway } from './LegrandGateway.model';
import { DebugConfigs, Operation } from '~/interfaces/device.interface';
import operations from '~/helpers/device-operations';
import apiService from '~/services/api.service';
import { DevicesModule } from '~/store/modules/devices';
import { connectivity } from '~/helpers/network-fields-description';

export class BNCX extends LegrandGateway {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    hasOperationImportData = false;

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
            operations.getLocalResources({ callback: this.getLocalResources }),
        ]);
    }

    async getDebugConfigs() {
        try {
            const configs = (await apiService.getdebugconfigs({ device_id: this.id })).data.body as DebugConfigs;
            const device = configs.home.modules.find((dev: { id: string }) => dev.id === this.id);
            if (device) {
                DevicesModule.addDeviceInfo({
                    deviceId: device.id,
                    additionalInfo: { debug_enabled: device.debug_enabled },
                });
            }
        } catch (error) {
            return;
        }
    }

    getNetworkFields() {
        const fields = super.getNetworkFields();
        fields.push(connectivity(this.network?.connection as string));
        return fields;
    }

    // Uncomment when embedded is ready

    // shouldGetDebugConfigs = true;
    // hasSwitchDebugMode = true;
    // debug_enabled = false;

    // setDebugValue = async (value: boolean) => {
    //     await this.handleOperation({
    //         callback: () => apiService.setdebugconfigs({ device_id: this.id, debug_enabled: value }),
    //     });
    // }
}
